<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <AssistantServiceTabLinks />

                    <AssistantServiceUpsertForm
                        class="mt-4"
                        :entity="entity"
                        @success="$router.push(`/assistants/${$route.params.id}/service/${$route.params.service_id}`)"
                        @deleted="$router.push(`/assistants/${$route.params.id}/service`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js'

    import AssistantServiceTabLinks from '@/components/assistant/AssistantServiceTabLinks'
    import AssistantServiceUpsertForm from '@/components/assistant/AssistantServiceUpsertForm'

    export default {
        components: {
            AssistantServiceTabLinks,
            AssistantServiceUpsertForm,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch()
        },

        methods: {
            async fetch() {
                const { id, service_id } = this.$route.params

                const [error, result] = await to(this.axios.get(`/assistants/${id}/services/${service_id}`))
                this.entity = result.data

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении. ' + error);
                }
            }
        }
    }
</script>
